import classnames from 'classnames';
import { useNavContext } from 'context/nav';
import { Activities } from './activities';
import styles from './detailed-nav.module.scss';
import { Features } from './features';
import { MainDetails } from './main-details';

export const DetailedNav = () => {
  const { activeCategory, handleCloseDetailedNav } = useNavContext();

  const hasFeatures = !!activeCategory?.hasFeatures;
  const showDetailedNav = !!activeCategory?.subCategories?.length;

  return (
    <div
      data-testid="nav-desktop__details_test-id"
      className={classnames(styles.detailedNavOuter, {
        [styles.showDetailedNav]: showDetailedNav,
      })}
      onMouseLeave={handleCloseDetailedNav}
    >
      {showDetailedNav && (
        <>
          <div className={styles.detailedNavRow}>
            <div className={styles.detailedNavInner}>
              {hasFeatures && <Features />}
              <MainDetails />
            </div>
          </div>
          <div className={styles.detailedNavActivitiesRow}>
            <div className={styles.detailedNavActivities}>
              <Activities />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
